/**
 * Webhooks outbound do tenant (F2 #4 · DOC 06 § 6.9).
 * JWT do painel — secret plano só em create/rotate (`data.secret`).
 */

import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

/** Eventos que o painel deixa assinar (≠ webhook.test). */
export const WEBHOOK_EVENT_OPTIONS = [
  "contact.created",
  "contact.updated",
  "message.sent",
  "message.failed",
  "campaign.send.completed",
] as const;

export type WebhookEventName = (typeof WEBHOOK_EVENT_OPTIONS)[number];

export type WebhookEndpoint = {
  id: number;
  url: string;
  events: string[];
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  /** Só após create/rotate — nunca na listagem. */
  secret?: string;
};

export type WebhookDelivery = {
  id: number;
  webhook_endpoint_id: number;
  event: string;
  status: string;
  attempts: number;
  last_http_status: number | null;
  last_error: string | null;
  created_at?: string;
  updated_at?: string;
};

export type WebhookWritePayload = {
  url: string;
  events: string[];
  is_active?: boolean;
  rotate_secret?: boolean;
};

export const getWebhooks = (): Promise<ApiSuccess<WebhookEndpoint[]>> => {
  return axios.get(apiBase + "/webhooks");
};

export const getWebhook = (
  id: number
): Promise<ApiSuccess<WebhookEndpoint>> => {
  return axios.get(apiBase + "/webhooks/" + id);
};

export const getWebhookDeliveries = (
  id: number
): Promise<ApiSuccess<WebhookDelivery[]>> => {
  return axios.get(apiBase + "/webhooks/" + id + "/deliveries");
};

export const createWebhook = (
  payload: WebhookWritePayload
): Promise<ApiSuccess<WebhookEndpoint>> => {
  return axios.post(apiBase + "/webhooks", payload);
};

export const updateWebhook = (
  id: number,
  payload: Partial<WebhookWritePayload>
): Promise<ApiSuccess<WebhookEndpoint>> => {
  return axios.patch(apiBase + "/webhooks/" + id, payload);
};

export const deleteWebhook = (
  id: number
): Promise<ApiSuccess<null>> => {
  return axios.delete(apiBase + "/webhooks/" + id);
};

export const testWebhook = (
  id: number
): Promise<
  ApiSuccess<{ delivery_id: number; event: string; status: string }>
> => {
  return axios.post(apiBase + "/webhooks/" + id + "/test");
};

export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    message?: string;
    response?: { data?: { error?: { message?: string }; message?: string } };
  };
  return (
    e?.response?.data?.error?.message ||
    e?.response?.data?.message ||
    e?.message ||
    fallback
  );
}
